module.exports = __webpack_public_path__ + "img/2.68be6d32.jpg";